import {
  CreateResourceRequest,
  DeleteResourceRequest,
  UpdateResourceRequest,
  ViewResourcesByTypeRequest
} from './resource.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/resource`;

export const getCreateResourceRequest = (
  data: CreateResourceRequest
): [string, HttpPostOptions<CreateResourceRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getUpdateResourceRequest = (
  data: UpdateResourceRequest
): [string, HttpPutOptions<UpdateResourceRequest>] => [getEndpoint(), getHttpPutOptions(data)];

export const getDeleteResourceRequest = (data: DeleteResourceRequest): [string, HttpDeleteOptions] => [
  `${getEndpoint()}/${data.programmeExternalReference}/${data.planExternalReference}/${data.resourceExternalReference}`,
  getHttpDeleteOptions()
];

export const getViewResourcesByTypeRequest = (data: ViewResourcesByTypeRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/${data.programmeExternalReference}/${data.documentType}`,
  getHttpGetOptions()
];
